import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

export const getClinicDentalServiceMasterByClinicId = createAsyncThunk(
  "clinicDentalServiceMaster/getClinicDentalServiceMasterByClinicId",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post("/clinicDentalServiceMaster/getClinicDentalServiceMasterByClinicId",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data.token
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message)
    }
  }
);

export const updateClinicDentalServiceDetails = createAsyncThunk(
  "clinicDentalServiceMaster/updateClinicDentalServiceDetails",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        "/clinicDentalServiceMaster/updateClinicDentalServiceDetails",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data.token
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const deleteClinicDentalServiceDetails = createAsyncThunk(
  "clinicDentalServiceMaster/deleteClinicDentalServiceDetails",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        "/clinicDentalServiceMaster/deleteClinicDentalServiceDetails",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data.token
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

const initialState = {
  loading: false,
  clinicDentalServiceMasterByClinicId: [],
  updateClinicDentalServiceDetailsSuccessMessage: null,
  updateClinicDentalServiceDetailsErrorMessage: null,
  deleteClinicDentalServiceDetailsSuccessMessage: null,
  deleteClinicDentalServiceDetailsErrorMessage: null,
};
const clinicDentalServiceMasterSlice = createSlice({
  name: "clinicDentalServiceMaster",
  initialState,
  reducers: {
    resetUpdateClinicDentalServiceDetailsMessage: (state) => {
      state.updateClinicDentalServiceDetailsSuccessMessage = null
      state.updateClinicDentalServiceDetailsErrorMessage = null
    },
    resetDeleteClinicDentalServiceDetailMessage: (state) => {
      state.deleteClinicDentalServiceDetailsSuccessMessage = null
      state.deleteClinicDentalServiceDetailsErrorMessage = null
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getClinicDentalServiceMasterByClinicId.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getClinicDentalServiceMasterByClinicId.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success === false) {
          state.clinicDentalServiceMasterErrorMessage = action.payload.result.message;
        } else {
          state.clinicDentalServiceMasterByClinicId = action.payload.result.list;
        }
      })
      .addCase(getClinicDentalServiceMasterByClinicId.rejected, (state, action) => {
        state.loading = false;
        state.clinicDentalServiceMasterErrorMessage = action.payload;
      })
      .addCase(deleteClinicDentalServiceDetails.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(deleteClinicDentalServiceDetails.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success === false) {
          state.deleteClinicDentalServiceDetailsErrorMessage = action.payload.result.message;
        } else {
          state.deleteClinicDentalServiceDetailsSuccessMessage = action.payload.result.message;
        }
      })
      .addCase(deleteClinicDentalServiceDetails.rejected, (state, action) => {
        state.loading = false;
        state.deleteClinicDentalServiceDetailsErrorMessage = action.payload;
      })
      .addCase(updateClinicDentalServiceDetails.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(updateClinicDentalServiceDetails.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success === false) {
          state.updateClinicDentalServiceDetailsErrorMessage = action.payload.result.message;
        } else {
          state.updateClinicDentalServiceDetailsSuccessMessage = action.payload.result.message;
        }
      })
      .addCase(updateClinicDentalServiceDetails.rejected, (state, action) => {
        state.loading = false;
        state.updateClinicDentalServiceDetailsErrorMessage = action.payload;
      });
  },
});

export const {
  resetUpdateClinicDentalServiceDetailsMessage,
  resetDeleteClinicDentalServiceDetailMessage
} = clinicDentalServiceMasterSlice.actions;

export default clinicDentalServiceMasterSlice.reducer;